import { authService } from '../../services/auth/authService';
import type { FirebaseLoginResult } from '../../entities/auth/firebaseLoginResult';

/**
 * SignInWithGoogleUseCase
 *
 * Runs the Google OAuth popup and returns the raw FirebaseLoginResult.
 * Mirrors Flutter's two-step login shape: the caller of this use case is
 * responsible for calling `SaveUserUseCase` next (see
 * `lib/presentation/screens/login/login_screen.dart:_login` lines 97-159).
 */
export class SignInWithGoogleUseCase {
    async execute(): Promise<FirebaseLoginResult> {
        return await authService.signInWithGoogle();
    }
}

export const signInWithGoogleUseCase = new SignInWithGoogleUseCase();
